import React, { Suspense, useState, useEffect, useRef } from "react";
import { useLocation, Link, useParams } from "react-router-dom";
import CVArthurCPP from "../Download/CV-Arthur-JV.png";
import CVArthurCPPEN from "../Download/ArthurCVJV-EN.png";
import DropdownTraduction from "./DropdownTraduction.js";
import { Loader } from "./ComponentTraduction";
import { withTranslation, useTranslation } from "react-i18next";

const NavbarT = ({ t, tabIndex }) => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const { lang = "fr" } = useParams();
  const pagePath = "/" + (location.pathname.split("/").slice(2).join("/") || "");

  const [menuOpen, setMenuOpen] = useState(false);
  const [showIncomingTitle, setShowIncomingTitle] = useState(false);

  const menuToggleRef = useRef(null);
  const navRef = useRef(null);


  useEffect(() => {
    const storedValue = sessionStorage.getItem("ShowTitleInNavbar");
    setShowIncomingTitle(storedValue === "true");
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setMenuOpen((prev) => !prev);
    }
  };

  useEffect(() => {
    if (menuOpen && navRef.current) {
      const focusableEls = navRef.current.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (focusableEls.length > 0) focusableEls[0].focus();
    }
  }, [menuOpen]);

  const handleNavKeyDown = (e) => {
    if (!menuOpen) return; // focus trap actif seulement si menu ouvert

    if (e.key === "Tab") {
      const focusableEls = navRef.current.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      const first = focusableEls[0];
      const last = focusableEls[focusableEls.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    } else if (e.key === "Escape") {
      setMenuOpen(false);
      menuToggleRef.current.focus();
    }
  };

  const handleNavClick = (path) => {
    setShowIncomingTitle(path === "/Incoming");
    sessionStorage.setItem("ShowTitleInNavbar", path === "/Incoming" ? "false" : "true");
  };

  const renderNavbarButton = (path, label) => {
    const isActive =
      path === ""
        ? pagePath === "/" || pagePath === "/Arthur" || pagePath === ""
        : pagePath === path;
    return (
      <li className="navbar-item">
        <Link
          className={`navbar-link${isActive ? " navbar-link--active" : ""}`}
          to={`/${lang}${path}`}
          onClick={() => handleNavClick(path)}
          tabIndex={menuOpen ? 0 : -1}
          aria-current={isActive ? "page" : undefined}
        >
          {t(label)}
        </Link>
      </li>
    );
  };

  const cvToDownload = i18n.language.startsWith("fr")
    ? CVArthurCPP
    : CVArthurCPPEN;
  const isHome = pagePath === "/" || pagePath === "/Arthur" || pagePath === "";

  return (
    <div className="navbar-container">
      {menuOpen && (
        <div
          className="navbar-backdrop"
          onClick={() => setMenuOpen(false)}
          aria-hidden="true"
        />
      )}
      <input
        ref={menuToggleRef}
        type="checkbox"
        id="menu-toggle"
        className="menu-toggle"
        checked={menuOpen}
        onChange={() => setMenuOpen((prev) => !prev)}
        tabIndex={-1}
      />
      <label
        htmlFor="menu-toggle"
        role="button"
        onKeyDown={handleKeyDown}
        tabIndex={tabIndex || 0}
        className={`${isHome ? "menu-icon-home" : "menu-icon"}`}
      >
        <span></span>
        <span></span>
        <span></span>
      </label>
      <nav
        ref={navRef}
        className="navbar-vertical"
        onKeyDown={menuOpen ? handleNavKeyDown : undefined}
      >
        <ul>
          <DropdownTraduction tabIndex={menuOpen ? 0 : -1} />
          {renderNavbarButton("", "ClassicNavBar.Home")}
          {renderNavbarButton("/Unity", "ClassicNavBar.Unity")}
          {renderNavbarButton("/Unreal", "ClassicNavBar.Unreal")}
          {renderNavbarButton("/Gamejam", "ClassicNavBar.GameJam")}
          {renderNavbarButton("/ProjectsVideosGames", "DropdownProjects.ProjectVideoGames")}
          {renderNavbarButton("/ProjectsWeb", "DropdownProjects.ProjectWeb")}
          {renderNavbarButton("/AI", "ClassicNavBar.AI")}
          {renderNavbarButton("/contactMe", "ClassicNavBar.ContactMe")}
          <li className="navbar-item">
            <a
              className="navbar-link"
              href={cvToDownload}
              target="_blank"
              rel="noreferrer"
              tabIndex={menuOpen ? 0 : -1}
            >
              {t("ClassicNavBar.CV")}
            </a>
          </li>
          {showIncomingTitle &&
            renderNavbarButton("/Incoming", "ClassicNavBar.Incoming")}
          <li className="navbar-item navbar-item--pro">
            <a
              className="navbar-link navbar-link--pro"
              href="https://www.arthur-bru.com"
              target="_blank"
              rel="noopener noreferrer"
              tabIndex={menuOpen ? 0 : -1}
            >
              {t("ClassicNavBar.SitePro")}
              <span className="navbar-link--pro-arrow" aria-hidden="true"> ↗</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
};

const TranslatedNavbar = withTranslation()(NavbarT);

export default function Navbar(props) {
  return (
    <Suspense fallback={<Loader />}>
      <TranslatedNavbar {...props} />
    </Suspense>
  );
}
